import moment from "moment"
import * as React from "react"
import { AppContextModel } from "../AppLayout"

export interface IAppContext {
    appContext: AppContextModel
}

export const AppContext = React.createContext<AppContextModel>({ Anno: moment().year(), StatoOperativo: 'Startup', DataStato: moment().toString()})

export function withAppContext<
    P extends IAppContext,
    R = Omit<P, 'appContext'>
>(
    Component: React.ComponentType<P>
): React.FC<R> {
    return function BoundComponent(props: R) {
        return (
            <AppContext.Consumer>
                {value => <Component {...props as any} appContext={value} />}
            </AppContext.Consumer>
        )
    }
}